export enum DIALOG_NAMES {
    ApiTokens = "apiTokens",
    BannerManagement = "bannerManagement",
    CompanyLevel = "companyLevel",
    SecurityAndAccount = "securityAndAccount"
}
